import Grid from '@mui/material/Grid';
import type { SxProps } from '@mui/material/styles';
import type { JSX } from 'react';
import { ActionButton, type ActionButtonProps } from './ActionButton';
import { MenuButton } from './MenuButton';
import { groupButtons } from './utils';

export interface HeaderActionsProps {
  actions: Array<ActionButtonProps>;
  sx?: SxProps;
}

const HeaderActions = ({ actions, sx }: HeaderActionsProps): JSX.Element => {
  const buttons = groupButtons(actions);

  return (
    <Grid
      container
      spacing={1}
      sx={{
        justifyContent: 'flex-end',
        alignItems: 'center',
        ...sx,
      }}
    >
      {buttons.showed.map(({ ...props }) => (
        <ActionButton {...props} key={props.label} />
      ))}
      {buttons.hidden.length ? <MenuButton actions={buttons.hidden} /> : null}
    </Grid>
  );
};

export { HeaderActions };
